<template>
  <div class="kefu">
    <van-popup v-model="show">
      <div class="kfcon">
        <div class="title"><img src="../../../assets/img/common/kf.png" /></div>
        <div class="h1">客服电话</div>
        <div class="h2">400-990-2557</div>
        <div class="h3">客服时间9:00-18:00</div>
        <van-button class="kfbtn" @click="callPhone" type="danger">立即拨打</van-button>
        <img class="close" src="../../../assets/img/common/close2.png" @click="closeShadow"  />
      </div>
    </van-popup>
  </div>
</template>

<script>
  export default {
    name: 'kefu',
    data() {
      return {
        show: false
      }
    },
    methods:{
      openShadow() {
        this.show = true
      },
      closeShadow() {
        this.show = false
      },
      callPhone() {
        window.location.href = 'tel:4009902557'
      }
    }
  }
</script>
<style lang="less">
  .kefu{
    .van-popup--center {
      border-radius: 20px;
      overflow:hidden;
    }
  }
</style>
<style lang="less" scoped>
  .kfcon{
    width: 630px;
    height: 460px;
    background: #FFFFFF;
    text-align:center;
    position:relative;
    .close{
      display:block;
      width:31px;
      height:31px;
      position:absolute;
      right:20px;
      top:20px;
    }
    .kfbtn{
      width:205px;
      height:60px;
      line-height:60px;
      font-weight: bold;
      font-size: 36px;
      color: #FFFFFF;
      border-radius:50px;
    }
    .title{
      text-align:center;
      padding-top:38px;
      margin-bottom:24px;
      img{
        width:96px;
        height:96px;
      }
    }
    .h1{
      font-weight: bold;
      font-size: 30px;
      color: #000000;
      line-height: 48px;
      text-align:center;
    }
    .h2{
      font-weight: bold;
      font-size: 36px;
      color: #000000;
      line-height: 48px;
      text-align:center;
    }
    .h3{
      font-weight: bold;
      font-size: 24px;
      color: #000000;
      line-height: 48px;
      text-align:center;
    }
  }
</style>
